import {
  MASTER_NODES_FIELD,
  MASTER_SYSTEM_DISK_FIELD,
  MASTER_SYSTEM_DISK_PRICING_FIELD,
  WORKER_NODES_FIELD,
  WORKER_SYSTEM_DISK_FIELD,
  WORKER_SYSTEM_DISK_PRICING_FIELD,
} from './nodeFieldNames';

/** 节点配置表单字段路径（支持 PD prefill/decode 等前缀场景） */
export interface MaasNodeGroupFieldPaths {
  runMode: string;
  masterNodes: string;
  workerNodes: string;
  masterSystemDisk: string;
  workerSystemDisk: string;
  masterSystemDiskPricing: string;
  workerSystemDiskPricing: string;
  /** 拓扑级副本数（inference.*.replicas） */
  replicas: string;
  /** 拓扑级任务模板（inference.*.taskTemplate） */
  taskTemplate: string;
  /** 拓扑级初始化命令表单前缀（如 initCommand / prefillInitCommand） */
  initCommand: string;
  /** 拓扑级环境变量 Form.List 字段 */
  commonEnv: string;
}

export const DEFAULT_MAAS_NODE_GROUP_FIELD_PATHS: MaasNodeGroupFieldPaths = {
  runMode: 'runMode',
  masterNodes: MASTER_NODES_FIELD,
  workerNodes: WORKER_NODES_FIELD,
  masterSystemDisk: MASTER_SYSTEM_DISK_FIELD,
  workerSystemDisk: WORKER_SYSTEM_DISK_FIELD,
  masterSystemDiskPricing: MASTER_SYSTEM_DISK_PRICING_FIELD,
  workerSystemDiskPricing: WORKER_SYSTEM_DISK_PRICING_FIELD,
  replicas: 'replicas',
  taskTemplate: 'taskTemplate',
  initCommand: 'initCommand',
  commonEnv: 'commonEnv',
};

export const PREFILL_MAAS_NODE_GROUP_FIELD_PATHS: MaasNodeGroupFieldPaths = {
  runMode: 'prefillRunMode',
  masterNodes: 'prefillMasterNodes',
  workerNodes: 'prefillWorkerNodes',
  masterSystemDisk: 'prefill.master.systemDiskSize',
  workerSystemDisk: 'prefill.worker.systemDiskSize',
  masterSystemDiskPricing: 'prefillMasterSystemDiskPricing',
  workerSystemDiskPricing: 'prefillWorkerSystemDiskPricing',
  replicas: 'prefillReplicas',
  taskTemplate: 'prefillTaskTemplate',
  initCommand: 'prefillInitCommand',
  commonEnv: 'prefillCommonEnv',
};

export const DECODE_MAAS_NODE_GROUP_FIELD_PATHS: MaasNodeGroupFieldPaths = {
  runMode: 'decodeRunMode',
  masterNodes: 'decodeMasterNodes',
  workerNodes: 'decodeWorkerNodes',
  masterSystemDisk: 'decode.master.systemDiskSize',
  workerSystemDisk: 'decode.worker.systemDiskSize',
  masterSystemDiskPricing: 'decodeMasterSystemDiskPricing',
  workerSystemDiskPricing: 'decodeWorkerSystemDiskPricing',
  replicas: 'decodeReplicas',
  taskTemplate: 'decodeTaskTemplate',
  initCommand: 'decodeInitCommand',
  commonEnv: 'decodeCommonEnv',
};
